import { LoadStatus } from '../../shipment-load/models';
import { TransportMode } from '../../../../common/constants';
import { DeviationType } from '../../../models';
import { Region } from '../../monitoring/transport/constants/transport-list.constant';

//moved from legacy transport order
export interface TransportOrderLoad {
  carrierId: string;
  carrierName: string;
  inTime: DeviationType;
  loadId: number;
  loadNumber: string;
  loadStatuses: LoadStatus[];
  plannedArrivalDateTime: number;
  origin: string;
  region: Region;
  speedUpInformation: string;
  transportMode: TransportMode;
  isCancelled: true;
}
